export default {
    UNAVAILABLE: "UNAVAILABLE",
    CAN_START: "CAN_START",
    IN_PROGRESS: "IN_PROGRESS",
    PROCESSED: "PROCESSED",
    ERROR: "ERROR"
}